module.exports = __webpack_public_path__ + "static/img/J.8a26db7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mssj/J.png
// module id = S1Zc
// module chunks = 0